import * as AppPics from 'assets/images';
import { AppButton } from 'components';
import DOMPurify from 'dompurify';
import useComments from 'hooks/API/GET/useComments';
import useManageComments from 'hooks/API/useManageComments';
import useReviewComment from 'hooks/API/useReviewComment';
import useOnClickOutside from 'hooks/useOnClickOutside';
import { useState, useEffect, createRef, useContext } from 'react';
import { COMMENT_IDENTIFIER, contentErrors, ROLES } from 'utilities/constants';
// import { DropdownMenu, DropdownItem } from 'reactstrap';
import { AiFillEdit, AiOutlineDelete } from 'react-icons/ai';
import { TiTick, TiTimes } from 'react-icons/ti';
// import VDots from 'components/DropDowns/VDots';
import Editor from 'components/CKEditor/Editor';
import CommentBoxParent from './CommentBoxParent';
import Alert from '@mui/material/Alert';
import { notifier } from 'components/Toaster';
// import UserSelect from 'components/molecules/UserSelect';
// import { UserContext } from 'context/UserContext';
import dayjs from 'dayjs';
import { UserContext } from 'context/UserContext';
import PickIssuesList from 'pages/manage-quiz/manage/Questions/PickIssuesList';
import Icons from 'assets/Icons';
import avatarSvg from 'pages/Layouts/Admin/avatar.svg';
import CommentBoxDelete from './CommentBoxDelete';

function CommentDropBox(props) {
  const { open, data = {}, close, updateBlock } = props;
  const {
    modalId,
    dataBlockId,
    commentText,
    apiBodyProps = {},
    replyModal = {},
    block = {},
  } = data;
  let { apiHash } = replyModal;
  if (!apiHash) apiHash = data?.apiHash;

  // const { userInfo = {} } = useContext(UserContext);

  const ref = createRef();
  useOnClickOutside(ref, () => close());

  const [issueType, setIssueType] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [reviewComment, setReviewComment] = useState('');
  const [reviewDetails, setReviewDetails] = useState({});
  const [reply, setReply] = useState('');
  const [destroy, setDestroy] = useState(false);
  const [editReply, setEditReply] = useState({});
  const [deleteModal, setDeleteModal] = useState({ isOpen: false, data: {} });

  const { isLoading, data: response = {} } = useComments({ enabled: !!apiHash, hashID: apiHash });

  const { isLoading: isAdding, mutate } = useReviewComment();

  const manageReply = useManageComments();

  useEffect(() => {
    if (editReply?.replyID) {
      setReply(editReply.text);
    }
  }, [editReply]);

  useEffect(() => {
    if (response?.data?._id) {
      setReviewDetails(response.data);

      if (Array.isArray(response.data?.issueType)) {
        const _arr = [];
        for (const [key, value] of Object.entries(contentErrors)) {
          if (response.data?.issueType?.includes(key)) _arr.push({ value: key, label: value });
        }
        setIssueType(_arr);
      }
      if (typeof response.data?.issueType === 'string' && response.data?.issueType)
        setIssueType([
          { value: response.data?.issueType, label: contentErrors[response.data?.issueType] },
        ]);

      setReviewComment(response.data?.reviewComment || '');
    }
  }, [response?.data]);

  function clear() {
    setIssueType([]);
    setReviewComment('');
    close();
  }

  function removeMarkingTag(dataApiHash) {
    const __htmlTag = document.querySelector(`[data-api-hash="${dataApiHash}"]`);

    if (__htmlTag) {
      const innerData = __htmlTag.innerHTML;
      const __dataBlockId = __htmlTag.getAttribute('data-tag-in-block-id');
      __htmlTag.replaceWith(innerData);

      const __html = document.querySelector(`[data-block-id="${__dataBlockId}"]`);
      updateBlock(__dataBlockId, __html.innerHTML, { noactivity: true });
    }

    clear();
  }

  function handleSave(args = {}) {
    if (isAdding) return;
    if (!issueType?.length) return;

    const hasNoIssues = issueType.every((item) => item.value !== 'no_issues');
    if (
      !['notes', 'geek_corner'].includes(apiBodyProps?.lessonType) &&
      hasNoIssues &&
      !`${reviewComment}`.trim()
    )
      return;

    const apiData = {
      issueType: issueType.map((item) => item.value),
      reviewComment: `${reviewComment}`.trim(),
      ...apiBodyProps,
      _id: reviewDetails?._id,
      denyUpdateCall: reviewDetails?.denyUpdateCall || false,
      type: reviewDetails?._id ? 'UPDATE' : 'CREATE',
      hasBlochHashComment: !!reviewDetails?.selectedBlock?._id,
      ...args,
    };

    // Execute this "if"; green tick is clicked
    if (args?.flag === 'EDIT_BUTTON_CLICK') {
      if (response?.data?.markResolved === true) apiData.resolved = true;
      if (response?.data?.markResolved !== true && response?.data?.markAsDone) {
        // do not remove colors-span and update/get not API not gone
        delete apiData.resolved;
        apiData.respondentResolve = true;
      }
    }
    if (args?.flag === 'EDIT_BUTTON_CLICK_UNRESOLVED') {
      if (response?.data?.markAsDone) apiData.respondentUnResolve = true;
      else apiData.markUnResolved = true;
    }
    // console.log('🚀 ~ handleSave ~ apiData:', apiData);
    // return true;
    mutate(apiData, {
      onSuccess(successData, variables) {
        if (variables?.type === 'DELETE') {
          notifier.success('Comment deleted successfully');
        }
        if (['UPDATE', 'CREATE'].includes(variables?.type)) {
          notifier.success('Comment posted successfully');
        }
        let removeMarking = variables?.type === 'DELETE';
        if (variables?.markResolved !== true && variables?.respondentResolve === true) {
          removeMarking = false;
        }
        if (variables?.denyUpdateCall === true) {
          removeMarking = false;
          return;
        }
        if (variables?.resolved) {
          removeMarking = true;
        }
        if (removeMarking) {
          if (reviewDetails?.selectedBlock?._id) {
            updateBlock(reviewDetails.selectedBlock._id, reviewDetails.selectedBlock.value, {
              removeBlockHas: true,
              noactivity: true,
            });

            clear();
            close();

            return;
          }

          removeMarkingTag(variables?._id);

          return;
        }

        // const __htmlTag = document.querySelector(`[data-id="${modalId}"]`);

        // if (__htmlTag) {
        //   const { hash, __issueConfig = [] } = successData?.data || {};
        //   const classList = __issueConfig?.map((x) => x.classList)?.join(', ') || '';

        //   __htmlTag.setAttribute('class', `${classList} displayPointer ${COMMENT_IDENTIFIER}`);
        //   __htmlTag.setAttribute('data-api-hash', hash);
        //   __htmlTag.setAttribute('data-tag-in-block-id', dataBlockId);

        //   const __html = document.querySelector(`[data-block-id="${dataBlockId}"]`);
        //   updateBlock(dataBlockId, __html.innerHTML);
        // }
        clear();
      },
    });
  }

  function handleReply(args = {}) {
    if (isAdding) return;
    if (!reviewDetails?._id) return;
    if (!`${reply}`.trim()) return;

    const apiData = {
      ...args,
      _id: reviewDetails._id,
      comment: `${reply}`.trim(),
    };

    mutate(apiData, {
      onSuccess() {
        setReply('');
        notifier.success('Reply posted successfully');
        setDestroy(true);
      },
    });
  }
  useEffect(() => {
    if (destroy) {
      setTimeout(() => {
        setDestroy(false);
      }, 1000);
    }
    return () => {};
  }, [destroy]);

  function modifyReply(args = {}) {
    if (isAdding) return;

    const apiData = {
      ...args,
      _id: reviewDetails._id,
    };

    mutate(apiData, {
      onSuccess() {
        setEditReply({});
        setReply('');
        setDestroy(true);
        setDeleteModal({ isOpen: false, data: {} });
      },
    });
  }

  const { userInfo = {} } = useContext(UserContext);
  const { key, _id } = userInfo?.data ?? {};

  const isSE = key === ROLES.SUBJECT_EXPERT;

  let doNorShowResolveBtn = isSE && response?.data?.respondentResolve;
  if (response?.data?.resolved && [ROLES.QC, ROLES.TUTOR].includes(key)) doNorShowResolveBtn = true;

  const __issues = [];
  if (!editMode && apiHash) {
    for (const [key, value] of Object.entries(contentErrors)) {
      if (Array.isArray(reviewDetails?.issueType) && reviewDetails?.issueType?.includes(key)) {
        __issues.push({ label: value, value: key });
      }
    }
  }

  let issueLabel = `RAISE AN ISSUE`;
  let resolvedCls = '';

  if (response?.data?.respondent === 'SUBJECT_EXPERT' && !response?.data?.respondentResolve) {
    issueLabel = `ISSUE UNRESOLVED`;
    resolvedCls = 'unresolved_se';
  }
  if (response?.data?.respondent === 'SUBJECT_EXPERT' && response?.data?.respondentResolve) {
    issueLabel = `SE MARKED COMPLETE`;
    resolvedCls = '';
  }
  if (response?.data?.resolved) {
    issueLabel = `ISSUE RESOLVED`;
    resolvedCls = '';
  }
  // console.log('🚀 ~ apiHash:', apiHash, !editMode, (editMode || !apiHash));
  return (
    <>
      <CommentBoxParent ref={ref} open={open}>
        <div className="modal-dialog modal-dialog-centered uploaddialog side-modal __preview_section">
          <div className="modal-content">
            {deleteModal.isOpen && (
              <CommentBoxDelete
                closeModal={() => {
                  setDeleteModal({ isOpen: false, data: {} });
                }}
                data={deleteModal.data}
                handleDelete={() => {
                  deleteModal.data?.handleDelete?.();
                }}
              />
            )}
            <div className={`modal-head ${resolvedCls}`}>
              <AppButton variantClass="btn invisible">
                <Icons.expandIconV1 />
              </AppButton>
              {/* <h2 className="popuptitle">{isLoading && 'Loading...'}</h2> */}
              <h2 className="popuptitle">{issueLabel}</h2>

              <AppButton variantClass="btn transp-bg-btn" onClick={close}>
                {resolvedCls !== '' ? <Icons.closeIconRed /> : <Icons.closeIcon />}
              </AppButton>
            </div>
            <div className="modal-body p-0 __review__blocks_quotes">
              <div className="container p-0">
                <div className="blockquote">
                  {!reviewDetails?._id && !commentText && <PrintText block={block} />}
                  {reviewDetails?._id && !reviewDetails?.commentText && (
                    <PrintText block={reviewDetails?.selectedBlock || {}} />
                  )}

                  {/* START OF ADD NEW COMMENT: SELECTED TEXT  */}
                  {!reviewDetails?._id && commentText && (
                    <blockquote>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(commentText || ''),
                        }}
                      />{' '}
                    </blockquote>
                  )}
                  {/* END OF ADD NEW COMMENT: SELECTED TEXT  */}

                  {/* START OF EXISTING COMMENT (from API): SELECTED TEXT  */}
                  {reviewDetails?._id && (
                    <blockquote>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(reviewDetails?.commentText || ''),
                        }}
                      ></p>{' '}
                    </blockquote>
                  )}
                  {/* START OF EXISTING COMMENT (from API):  SELECTED TEXT  */}
                  {reviewDetails?.respondentBy?.name && (
                    <Alert severity="success">
                      {reviewDetails?.respondentBy?.name} has responded to this comment.
                    </Alert>
                  )}

                  {/* {!reviewDetails?._id && [ROLES.ADMIN, ROLES.QC].includes(userInfo?.data?.key) && (
                  <UserSelect dependencies={{ query: { roles: [ROLES.SUBJECT_EXPERT] } }} />
                )} */}
                </div>
                {(editMode || !apiHash) && (
                  <div className="commentsection">
                    <div className="w-100 mt-3 select-issue">
                      <PickIssuesList
                        isMulti
                        values={issueType}
                        handleChange={(data) => {
                          if (Array.isArray(data)) {
                            const hasNoIssues = data.find((item) => item.value === 'no_issues');

                            if (hasNoIssues) setIssueType([hasNoIssues]);
                            if (!hasNoIssues) setIssueType(data);
                          }
                        }}
                      />
                    </div>
                    <div className="w-100 mt-3  -negate-padding-20">
                      <Editor
                        config={{
                          toolbar: [{ items: ['Bold', 'Italic', 'Image'] }],
                          toolbarGroups: [],
                        }}
                        data={{
                          value: reviewComment || '',
                          onChange: (editorData) => {
                            setReviewComment(editorData);
                          },
                        }}
                      />
                    </div>
                  </div>
                )}
                {!editMode && apiHash && (
                  <div className=" m-0 p-0 bg-transparent mt-3 ___edpod_rov__Commen">
                    <div className="row m-0 p-0 ">
                      <div className="col-12 p-0 m-0 ">
                        <div className="card border-0 rounded">
                          <div className="card-header p-1 bg-light border border-top-0 border-left-0 border-right-0 flex-btns -addpadd-20-lr">
                            <div className="__metaInvof">
                              <div className="__issueShort">
                                <h4> Issue Genre: </h4>
                                {/* <span> {contentErrors[reviewDetails?.issueType] || ''} </span> */}
                                <span>
                                  {__issues.map((item, i) => (
                                    <button
                                      key={i + item.label}
                                      type="button"
                                      class="btn btn-sm btn-outline-danger mx-1"
                                    >
                                      {item.label}
                                    </button>
                                  ))}
                                </span>
                              </div>
                              <div className="__issueDefn">
                                <h4> Issue Brief: </h4>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(reviewDetails?.reviewComment),
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                          <div class="d-flex my-4 -addpadd-20-lr d-flex-wrap btn-mrt-10">
                            <AppButton
                              className={`btn-plane g--tint g-tinted-gradient mar-rgt-12 ${
                                doNorShowResolveBtn ? 'd-none' : ''
                              }`}
                              onClick={() =>
                                handleSave({ resolved: true, flag: 'EDIT_BUTTON_CLICK' })
                              }
                            >
                              {response?.data?.markAsDone ? 'Mark Done' : 'Mark RESOLVED'}{' '}
                              <img
                                src={AppPics.SEDONE}
                                alt="resolve-btn"
                                title={response?.data?.markAsDone ? 'Complete' : 'Resolve'}
                                height={16}
                                width={16}
                              />
                            </AppButton>
                            <AppButton
                              className={`btn-plane g--tint g-tinted-gradient-reverse ${
                                doNorShowResolveBtn ? 'd-none' : ''
                              }`}
                              onClick={() =>
                                handleSave({
                                  resolved: false,
                                  flag: 'EDIT_BUTTON_CLICK_UNRESOLVED',
                                })
                              }
                            >
                              {response?.data?.markAsDone ? 'Mark Not Done' : 'Mark UNRESOLVED'}{' '}
                              <img
                                src={AppPics.SEUNDONE}
                                alt="resolve-btn"
                                title={
                                  response?.data?.markAsDone ? 'Mark Not Done' : 'Mark UNRESOLVED'
                                }
                                height={16}
                                width={16}
                              />
                            </AppButton>
                            {!isSE && reviewDetails?.askedBy === _id && (
                              <>
                                <AppButton
                                  variantClass="btn-plane mx-4"
                                  onClick={() => {
                                    setEditMode(true);
                                  }}
                                >
                                  Edit issue
                                </AppButton>
                                <AppButton
                                  variantClass="btn-plane p--tint mx-4"
                                  onClick={() => {
                                    setDeleteModal({
                                      isOpen: true,
                                      data: {
                                        apiPayload: { type: 'DELETE', _id: reviewDetails?._id },
                                        headingText: 'Delete Issue',
                                        handleDelete() {
                                          if (manageReply.isLoading) return;

                                          manageReply.mutate(
                                            { type: 'DELETE', _id: reviewDetails?._id },
                                            {
                                              onSuccess(data, variables) {
                                                notifier.success('Comment deleted successfully');

                                                removeMarkingTag(variables?._id);

                                                close();

                                                return;
                                              },
                                            }
                                          );
                                        },
                                      },
                                    });
                                  }}
                                >
                                  Delete issue
                                </AppButton>
                              </>
                            )}
                          </div>
                          <div class="card text-center app-l-comments-wrapper">
                            <div class="card-header">COMMENTS & ACTIVITY</div>
                            <div class="card-body">
                              <ul class="list-group list-group-flush">
                                {reviewDetails?.replyComment?.map?.((item, i) => {
                                  if (item.commentType === 'activity') {
                                    return (
                                      <li class="list-group-item" key={item._id}>
                                        <img src={avatarSvg} alt="Avatar" height={32} width={32} />

                                        <div>
                                          {item.text === 'created_issue' && (
                                            <span>
                                              {item.createdBy?.name}{' '}
                                              {i === 0
                                                ? `raised ${
                                                    __issues && __issues.length === 1
                                                      ? `an`
                                                      : `${__issues.length}`
                                                  } issue${
                                                    __issues && __issues.length === 1 ? `` : `s`
                                                  }`
                                                : `added a new comment`}
                                              .
                                            </span>
                                          )}
                                          {item.text === 'updated_issue' && (
                                            <span>{item.createdBy?.name} updated the issue.</span>
                                          )}
                                          {item.text === 'deleted_issue' && (
                                            <span>{item.createdBy?.name} deleted the issue.</span>
                                          )}
                                          {item.text === 'marked_resolved' && (
                                            <span>
                                              {item.createdBy?.name} marked this issue as resolved.
                                            </span>
                                          )}
                                          {item.text === 'respondent_responded' && (
                                            <span>{item.createdBy?.name} marked as done.</span>
                                          )}
                                          {item.text === 'un_done' && (
                                            <span>
                                              {item.createdBy?.name} marked this issue as not done.
                                            </span>
                                          )}{' '}
                                          {item.text === 'un_resolved' && (
                                            <span>
                                              {item.createdBy?.name} marked this issue as NOT
                                              RESOLVED.
                                            </span>
                                          )}
                                          <span>
                                            {/* <em>{item?.createdBy?.name}</em>{' '} */}
                                            {dayjs(item.createdOn).format('DD MMM YYYY, h:mm a')}
                                          </span>
                                        </div>
                                      </li>
                                    );
                                  }
                                  return (
                                    <li class="list-group-item" key={item._id}>
                                      <img src={avatarSvg} alt="Avatar" height={32} width={32} />
                                      <div className="position-relative">
                                        {!item.freeze && (
                                          <section
                                            className="position-absolute"
                                            style={{ bottom: '-18px', left: 0 }}
                                          >
                                            <span
                                              className="displayPointer"
                                              role="button"
                                              onClick={() => {
                                                setEditReply({
                                                  replyID: item._id,
                                                  text: item.text,
                                                });
                                              }}
                                            >
                                              <AiFillEdit color="primary" />
                                            </span>
                                            <span
                                              className="displayPointer mx-2"
                                              role="button"
                                              onClick={() => {
                                                setDeleteModal({
                                                  isOpen: true,
                                                  data: {
                                                    headingText: 'Delete Comment',
                                                    handleDelete() {
                                                      modifyReply({
                                                        type: 'DELETE',
                                                        configs: {
                                                          params: { replyID: item._id },
                                                        },
                                                      });
                                                    },
                                                  },
                                                });
                                              }}
                                            >
                                              <AiOutlineDelete color="red" />
                                            </span>
                                          </section>
                                        )}
                                        <small
                                          className="__replyComments"
                                          dangerouslySetInnerHTML={{
                                            __html: DOMPurify.sanitize(item.text),
                                          }}
                                        ></small>
                                        <span>
                                          <em>{item?.createdBy?.name}</em>{' '}
                                          {dayjs(item.createdOn).format('DD MMM YYYY, h:mm a')}
                                        </span>
                                      </div>
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                          </div>
                          {/* <div className="card bg-sohbet border-0 m-0 p-4 px-5 __Review__secc">
                             <div
                              id="sohbet"
                              className="card border-0 m-0 p-0 position-relative bg-transparent"
                            >
                              {Array.isArray(reviewDetails?.replyComment) &&
                                reviewDetails?.replyComment?.map((item) => {
                                  return (
                                    <div
                                      className="balon2 p-2 m-0 position-relative"
                                      key={item._id}
                                    >
                                      {' '}
                                      <span className="float-left sohbet2">
                                        <span
                                          className="sohbet3"
                                          dangerouslySetInnerHTML={{
                                            __html: DOMPurify.sanitize(item.text),
                                          }}
                                        ></span>
                                        {!item.freeze && (
                                          <VDots>
                                            <DropdownMenu>
                                              <DropdownItem
                                                onClick={() => {
                                                  setEditReply({
                                                    replyID: item._id,
                                                    text: item.text,
                                                  });
                                                }}
                                              >
                                                <AiFillEdit />
                                                Edit
                                              </DropdownItem>
                                              <DropdownItem
                                                onClick={() => {
                                                  const confirmed = window.confirm(
                                                    'Please confirm your action'
                                                  );

                                                  if (confirmed) {
                                                    modifyReply({
                                                      type: 'DELETE',
                                                      configs: {
                                                        params: { replyID: item._id },
                                                      },
                                                    });
                                                  }
                                                }}
                                              >
                                                <AiOutlineDelete />
                                                Delete
                                              </DropdownItem>
                                            </DropdownMenu>
                                          </VDots>
                                        )}
                                      </span>
                                      {item?.createdBy?.name && (
                                        <div className="text-right">
                                          <small>
                                            <em>{item?.createdBy?.name}</em>{' '}
                                            {item?.createdOn && (
                                              <>
                                                {dayjs(item.createdOn).format(
                                                  'DD MMM YYYY, h:mm a'
                                                )}
                                              </>
                                            )}
                                          </small>
                                        </div>
                                      )}
                                    </div>
                                  );
                                })}
                            </div> 
                          </div>*/}
                          <div
                            className="w-100  -negate-padding-20"
                            style={{ maxHeight: '180px', overflowY: 'auto' }}
                          >
                            {destroy && <p>...</p>}
                            {!destroy && (
                              <Editor
                                config={{
                                  toolbar: [{ items: ['Bold', 'Italic', 'Image'] }],
                                  toolbarGroups: [],
                                }}
                                data={{
                                  value: reply || '',
                                  onChange: (editorData) => {
                                    setReply(editorData);
                                  },
                                }}
                              />
                            )}
                          </div>
                          {/*  <div className="w-100  p-0 bg-light ">
                            <form className="m-0 p-0" autocomplete="off">
                              <div className="row m-0 p-0">
                                <div className="w-100 mt-3  -negate-padding-20">
                                  {destroy && <p>...</p>}
                                  {!destroy && (
                                    <Editor
                                      config={{
                                        toolbar: [{ items: ['Bold', 'Italic', 'Image'] }],
                                        toolbarGroups: [],
                                      }}
                                      data={{
                                        value: reply || '',
                                        onChange: (editorData) => {
                                          setReply(editorData);
                                        },
                                      }}
                                    />
                                  )}
                                </div>
                                <div className="col-3 m-0 p-1">
                                  {/* {!editReply?.replyID && (
                                    <AppButton
                                      variantClass="btn btn-outline-secondary rounded border w-100  replybtn"
                                      title="Click to reply"
                                      onClick={() => handleReply()}
                                    >
                                      Reply
                                    </AppButton>
                                  )} 
                                  {/* {editReply?.replyID && (
                                    <>
                                      <AppButton
                                        variantClass="btn btn-success mx-2"
                                        style={{ fontSize: '12px' }}
                                        onClick={() => {
                                          modifyReply({
                                            type: 'UPDATE',
                                            replyID: editReply.replyID,
                                            reply,
                                          });
                                        }}
                                      >
                                        <TiTick />
                                      </AppButton>
                                      <AppButton
                                        variantClass="btn btn-danger mx-2"
                                        style={{ fontSize: '12px' }}
                                        onClick={() => {
                                          setEditReply({});
                                          setReply('');
                                        }}
                                      >
                                        <TiTimes />
                                      </AppButton>
                                    </>
                                  )} 
                                </div>
                              </div>
                            </form>
                          </div>*/}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="modal-footer">
              {(editMode || !apiHash) && (
                <AppButton
                  variantClass="btn "
                  onClick={() => {
                    if (manageReply.isLoading) return;
                    if (!issueType.length) return;

                    const hasNoIssues = issueType.every((item) => item.value !== 'no_issues');

                    const needConfirmation = !hasNoIssues;
                    if (needConfirmation) {
                      const hasConfirmed = window.confirm('Are you sure you there are no issues?');
                      if (!hasConfirmed) return;
                    }

                    const obj = {
                      type: 'CREATE',
                      reviewComment,
                      issueType: issueType.map((x) => x.value),
                      selectedBlock: block,
                      ...apiBodyProps,
                    };

                    if (reviewDetails?._id) {
                      obj._id = reviewDetails?._id;
                      obj.type = 'UPDATE';
                    }

                    manageReply.mutate(obj, {
                      onSuccess(data, variables) {
                        if (variables?.type === 'UPDATE')
                          notifier.success('Comment updated successfully');
                        if (variables?.type === 'CREATE') {
                          notifier.success('Comment added successfully');
                          const __htmlTag = document.querySelector(`[data-id="${modalId}"]`);

                          if (!variables?.selectedBlock?._id && __htmlTag) {
                            const { hash, __issueConfig = [] } = data?.data || {};
                            let classList =
                              __issueConfig
                                ?.map((x) => x.classList)
                                ?.flat(Infinity)
                                ?.join(' ') || '';

                            if (__issueConfig?.length > 1) {
                              classList = 'text-multiple-issues';
                            }

                            __htmlTag.setAttribute(
                              'class',
                              `${classList} displayPointer ${COMMENT_IDENTIFIER}`
                            );
                            __htmlTag.setAttribute('data-api-hash', hash);
                            __htmlTag.setAttribute('data-tag-in-block-id', dataBlockId);

                            const __html = document.querySelector(
                              `[data-block-id="${dataBlockId}"]`
                            );
                            updateBlock(dataBlockId, __html.innerHTML, { noactivity: true });
                          }

                          if (variables?.selectedBlock?._id) {
                            updateBlock(
                              variables.selectedBlock._id,
                              variables.selectedBlock.value,
                              {
                                commentBlockHash: data?.data?.hash,
                                noactivity: true,
                              }
                            );
                          }
                        }

                        setEditMode(false);
                        clear();
                        close();
                        const __floatingBubble = document.getElementById(
                          'floating-selection-bubble'
                        );
                        if (__floatingBubble) __floatingBubble.style.display = 'none';
                      },
                    });
                  }}
                >
                  Save
                </AppButton>
              )}
              {!editReply?.replyID && (
                <AppButton variantClass="btn " title="Click to reply" onClick={() => handleReply()}>
                  Reply
                </AppButton>
              )}
              {editReply?.replyID && (
                <>
                  <AppButton
                    variantClass="btn "
                    // style={{ fontSize: '12px' }}
                    onClick={() => {
                      modifyReply({
                        type: 'UPDATE',
                        replyID: editReply.replyID,
                        reply,
                      });
                    }}
                  >
                    Send
                  </AppButton>
                  <AppButton
                    variantClass="btn"
                    // style={{ fontSize: '12px' }}
                    onClick={() => {
                      setEditReply({});
                      setReply('');
                    }}
                  >
                    Cancel
                    {/* <TiTimes /> */}
                  </AppButton>
                </>
              )}
            </div>
          </div>
        </div>
      </CommentBoxParent>
    </>
  );
}

function PrintText({ block, hideCaption }) {
  if (block?.currentBlock) {
    return (
      <blockquote>
        {block?.currentBlock === 'image' && 'Image block'}
        {block?.currentBlock === 'video' && 'Video block'}
        {block?.currentBlock === 'file' && 'File block'}
        {block?.currentBlock === 'audio' && 'Audio block'}
        {block?.currentBlock === 'equation' && 'Equation block'}
        {!hideCaption && (
          <p
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(block?.caption || ''),
            }}
          />
        )}{' '}
      </blockquote>
    );
  }
  return null;
}

export { PrintText };
export default CommentDropBox;
